// extracted by mini-css-extract-plugin
module.exports = {"TextWithImage":"TextWithImage_TextWithImage__pBFcI"};